var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = { class: "bg-grey-EC mt-24 tablet:pb-8" };
var _hoisted_2 = { class: "w-full tablet:max-w-1112px mx-auto px-0 py-16 tablet:p-32px" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "p-8 mx-6 tablet:mx-0 rounded border border-black bg-white" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-14px" }, "エンゲートというサービスに登録されます。すでに登録済みの方はエンゲートアカウントでログインができます。")
], -1);
var _hoisted_4 = { class: "mt-16 tablet:mt-32px bg-white shadow-md" };
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("h3", { class: "p-4 text-white bg-grey-33" }, " メールアドレスでログイン／新規登録する ", -1);
var _hoisted_6 = { class: "p-6 py-16" };
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-4 text-12px" }, "メールアドレス、パスワードは必須です", -1);
var _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-8 p-8 text-14px bg-gray-200 border border-dialog rounded" }, " 新規登録の方はご登録したいメールアドレスとパスワードをご入力後、「新規登録」ボタンを押してください。 ", -1);
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-8 text-12px" }, "既に会員の方はご登録済みのメールアドレスとパスワードをご入力後、「ログイン」ボタンを押してください。", -1);
var _hoisted_10 = { class: "" };
var _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "text-link-color leading-none text-10px" }, "使用できないメールアドレスについて", -1);
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-arrow_right2 text-link-color text-24px" }, null, -1);
var _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
var _hoisted_14 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-4 text-12px" }, " ※パスワードは8文字以上の大文字、数字をそれぞれ1文字以上含む半角英数字記号を入力してください ", -1);
var _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-8 text-center text-link-color text-12px font-semibold" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://engate.jp/term/",
        target: "_blank",
        rel: "noopenner"
    }, "会員規約に同意の上、会員登録を進めてください。")
], -1);
var _hoisted_16 = { class: "flex justify-center mt-8" };
var _hoisted_17 = { class: "mr-4" };
var _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-8 text-center text-link-color text-14px" }, [
    /*#__PURE__*/ _createElementVNode("a", { href: "/reset-password/" }, " パスワードをお忘れの方はこちら ")
], -1);
var _hoisted_19 = { class: "mt-16 tablet:mt-32px pb-8 bg-white shadow-md" };
var _hoisted_20 = /*#__PURE__*/ _createElementVNode("h3", { class: "p-4 text-white text-14px bg-grey-33" }, " SNSアカウントでログイン／新規登録する ", -1);
var _hoisted_21 = { class: "p-4" };
var _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-4 text-12px" }, " お持ちのSNSアカウントでログイン／新規登録いただけます。連携後、メールアドレスの登録が必要です。 ", -1);
var _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-8 text-center text-link-color text-12px font-semibold" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://engate.jp/term/",
        target: "_blank",
        rel: "noopenner"
    }, "会員規約に同意の上、会員登録を進めてください。")
], -1);
var _hoisted_24 = ["onClick"];
var _hoisted_25 = ["src", "alt"];
import { ref, reactive, computed } from 'vue';
import InputEmail from '../atoms/inputEmail.vue';
import InputPassword from '../atoms/inputPassword.vue';
import Button from '../atoms/Button.vue';
import LoadingProcessing from '../atoms/LoadingProcessing.vue';
import NotAvailableEmailModal from '../molecules/NotAvailableEmailModal.vue';
import { useAcknowledgementStore, useAuthStore, useProfileStore } from "../../store";
import { setCookie, getCookie, removeCookie } from '../../utils/cookies';
import * as $gtag from "vue-gtag";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    props: {
    // プロパティの定義
    },
    emits: [
    // イベントの定義
    ],
    setup: function (__props, _a) {
        var _this = this;
        var emits = _a.emit;
        var props = __props;
        var acknowledgementStore = useAcknowledgementStore();
        var authStore = useAuthStore();
        var profileStore = useProfileStore();
        var isProcessing = ref(false);
        var isModalOpen = ref(false);
        var email = ref('');
        var password = ref('');
        // const isClearSubmit = ref(false)
        var isValid = reactive({
            email: false,
            password: false,
        });
        var openModal = function (event) {
            event.preventDefault();
            isModalOpen.value = true;
        };
        var closeModal = function () {
            console.log('emit?');
            isModalOpen.value = false;
        };
        var updateEmail = function (event) {
            email.value = event.value;
            isValid.email = event.isValid;
        };
        var updatePassword = function (event) {
            password.value = event.value;
            isValid.password = event.isValid;
        };
        var signIn = function () { return __awaiter(_this, void 0, void 0, function () {
            var data, landingPage, domain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isProcessing.value = true;
                        isValid.email = false;
                        isValid.password = false;
                        return [4 /*yield*/, authStore.signIn({ email: email.value, password: password.value })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data.api_token) {
                            landingPage = getCookie('afterSignin') || '/';
                            removeCookie('afterSignin');
                            acknowledgementStore.showAcknowledgement({
                                code: data.code,
                                message: data.message,
                                to: landingPage,
                            });
                            domain = window.location.host;
                            if (domain === 'media.engate.jp') {
                                $gtag.event('click', { event_category: 'login', event_label: 'login_email' });
                            }
                        }
                        else {
                            isProcessing.value = false;
                            isValid.email = true;
                            isValid.password = true;
                            acknowledgementStore.showAcknowledgement({
                                code: data.code,
                                message: data.message,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var signUp = function () { return __awaiter(_this, void 0, void 0, function () {
            var option, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isProcessing.value = true;
                        isValid.email = false;
                        isValid.password = false;
                        option = {
                            expires: 1,
                            domain: '.engate.jp',
                            path: '/',
                        };
                        setCookie('referrerSite', 'engatemedia', option);
                        return [4 /*yield*/, authStore.signUp({ email: email.value, password: password.value })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data.message == '認証メールを送信しました') {
                            acknowledgementStore.showAcknowledgement({
                                code: data.code,
                                message: data.message,
                                to: '/registrations/sentmail/',
                            });
                        }
                        else if (data.message) {
                            isProcessing.value = false;
                            isValid.email = true;
                            isValid.password = true;
                            acknowledgementStore.showAcknowledgement({
                                code: data.code,
                                message: data.message,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var signInWithOAuth = function (provider) { return __awaiter(_this, void 0, void 0, function () {
            var option, data, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isProcessing.value = true;
                        isValid.email = false;
                        isValid.password = false;
                        option = {
                            expires: 1,
                            domain: '.engate.jp',
                            path: '/',
                        };
                        setCookie('referrerSite', 'engatemedia', option);
                        return [4 /*yield*/, authStore.oauth(provider)];
                    case 1:
                        data = (_a.sent()).data;
                        url = data['url'];
                        if (url) {
                            window.location.href = url;
                        }
                        else {
                            isProcessing.value = false;
                            isValid.email = true;
                            isValid.password = true;
                            acknowledgementStore.showAcknowledgement({
                                code: data.code,
                                message: data.message,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var snsBtns = [
            {
                id: 'facebook',
                src: '/assets/img/icon/facebook.svg',
                label: 'Facebook',
                authId: 'facebook',
                btnClass: 'hover relative flex justify-center mt-8 py-4 w-full bg-facebook rounded shadow',
                imgClass: 'absolute left-6',
            },
            {
                id: 'google',
                src: '/assets/img/icon/google.svg',
                label: 'Google',
                authId: 'google_oauth2',
                btnClass: 'hover relative flex justify-center mt-8 py-4 w-full bg-white border border-grey-60 rounded shadow',
                imgClass: 'absolute left-6 top-3',
            },
        ];
        var isClearSubmit = computed(function () {
            return !(isValid.email && isValid.password);
        });
        var buttonStyle = {
            backgroundColor: '#1565C0',
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bold',
            border: 'none',
            width: '160px',
            height: '48px',
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("section", _hoisted_4, [
                            _createElementVNode("form", { onSubmit: signIn }, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(InputEmail, {
                                            value: email.value,
                                            onUpdateValue: updateEmail,
                                            onCheckInputValue: updateEmail,
                                            requiredMessage: "入力してください"
                                        }, null, 8, ["value"]),
                                        _createElementVNode("button", {
                                            class: "text-hover ml-auto flex flex-row items-center justify-end mb-4",
                                            onClick: openModal
                                        }, _hoisted_13),
                                        _createVNode(NotAvailableEmailModal, {
                                            open: isModalOpen.value,
                                            onOnClose: closeModal
                                        }, null, 8, ["open"])
                                    ]),
                                    _createVNode(InputPassword, {
                                        value: password.value,
                                        required: true,
                                        placeholder: "パスワード",
                                        onUpdateValue: updatePassword,
                                        onCheckTextLength: updatePassword
                                    }, null, 8, ["value"]),
                                    _hoisted_14,
                                    _hoisted_15,
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _createVNode(Button, {
                                                class: "hover",
                                                text: "ログイン",
                                                buttonStyle: buttonStyle,
                                                onOnDoAction: signIn,
                                                disabled: isClearSubmit.value
                                            }, null, 8, ["disabled"])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createVNode(Button, {
                                                class: "hover",
                                                text: "新規登録",
                                                buttonStyle: buttonStyle,
                                                onOnDoAction: signUp,
                                                disabled: isClearSubmit.value
                                            }, null, 8, ["disabled"])
                                        ])
                                    ]),
                                    _hoisted_18
                                ])
                            ], 32)
                        ]),
                        _createElementVNode("section", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _hoisted_23,
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(snsBtns, function (snsBtn) {
                                    return _createElementVNode("button", {
                                        key: snsBtn.id,
                                        type: "button",
                                        class: _normalizeClass(snsBtn.btnClass),
                                        onClick: _withModifiers(function ($event) { return (signInWithOAuth(snsBtn.authId)); }, ["prevent"])
                                    }, [
                                        _createElementVNode("img", {
                                            src: snsBtn.src,
                                            alt: snsBtn.label,
                                            class: _normalizeClass(snsBtn.imgClass)
                                        }, null, 10, _hoisted_25),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["text-14px", { 'text-white': snsBtn.label !== 'Google' }])
                                        }, _toDisplayString(snsBtn.label), 3)
                                    ], 10, _hoisted_24);
                                }), 64))
                            ])
                        ])
                    ])
                ]),
                _createVNode(LoadingProcessing, {
                    class: "z-[75] opacity-70 fixed bottom-0 left-0 right-0 top-0 flex items-center justify-center w-full h-full",
                    "is-loading": isProcessing.value,
                    "animate-class": "animate-pulse"
                }, null, 8, ["is-loading"])
            ], 64));
        };
    }
});
